import { Config } from '.';

const config: Config = {
    API_URL: 'https://ga-management-tool-api.madeatsilverchip.com',
};

export default config;
